<template>
  <div v-if="isChecklistActive" class="checklist__next-step">
    <AppCheckbox :id="`checklist-next-step--${checklistId}`" :label="label" @input="nextStep" />
  </div>
</template>

<script>
// Utilities
import ChecklistsMixin from '../mixins'
import { checklistsGetters } from 'Store/helpers'
// Components
import AppCheckbox from 'Ui/AppCheckbox'

export default {
  name: 'ChecklistsChecklistNextStep',

  components: {
    AppCheckbox,
  },

  mixins: [ChecklistsMixin],

  props: {
    checklistId: {
      type: [Number, String],
      required: true,
    },
  },

  methods: {
    async nextStep() {
      const checklistData = this.getChecklistData({
        checklistId: this.checklistId,
        newData: { is_active: false },
      })
      const update = await this.$store.dispatch('checklists/updateChecklist', checklistData)
      if (!this.checkApiResponse(update)) return
      // checkig for next step
      if (!this.nextTask || this.isNextChecklistCompleted || this.isNextChecklistActive) return
      // activating next checklist
      const newTask = this.getChecklistData({
        // creo que mejor buscarlo por el orden
        // a checar cuando hagamos clon de template
        checklistId: this.checklistId + 1,
        newData: { is_active: true },
      })
      await this.$store.dispatch('checklists/updateChecklist', newTask)
    },
  },

  computed: {
    ...checklistsGetters,

    nextTask() {
      return this.getChecklist(this.checklistId + 1)
    },

    isChecklistActive() {
      return this.getChecklist(this.checklistId).is_active
    },

    isNextChecklistCompleted() {
      return this.isChecklistCompleted(this.nextTask.id)
    },

    isNextChecklistActive() {
      return this.getChecklist(this.nextTask.id).is_active
    },

    label() {
      return this.nextTask && !this.isNextChecklistCompleted && !this.isNextChecklistActive
        ? 'Activar el siguiente paso'
        : 'Paso completado'
    },
  },
}
</script>

<style scoped>
.checklist__next-step {
  padding: 10px 0;
}
</style>
